export default "__VITE_ASSET__DwSMbt8c__"